import React from "react";
import PdfAnnotator from "./pdfViewer";
import ImageAnnotator from "./imageAnnotator";

const getParamsFromQuery = () => {
  const params = new URLSearchParams(window.location.search);

  // Utility to return 0 if the param is missing or 'null'
  const getParamOrZero = (key) => {
    const val = params.get(key);
    return val && val !== "null" ? val : "0";
  };

  return {
    fileUrl: params.get("fileurl"),
    studentId: getParamOrZero("student_id"),
    fileId: getParamOrZero("file_id"),
    instId: getParamOrZero("inst_id"),
    authToken: params.get("auth"),
    attachId: getParamOrZero("attachment_id"),
    fileName: (() => {
      const url = params.get("fileurl");
      if (!url) return "annotated.pdf";
      try {
        return decodeURIComponent(url.split("/").pop().split("?")[0]);
      } catch {
        return "annotated.pdf";
      }
    })(),
  };
};


const getToolVisibility = () => {
  const params = new URLSearchParams(window.location.search);
  const getBool = (key, defaultVal = true) => {
    const val = params.get(key);
    return val === null ? defaultVal : val === "true";
  };
  return {
    pencil: getBool("showPencil"),
    text: getBool("showText"),
    highlight: getBool("showHighlight"),
    freeDrawing: getBool("showFreeDrawing"),
    symbol: getBool("showSymbol"),
    color: getBool("showColor"),
    size: getBool("showSize"),
    undo: getBool("showUndo"),
    redo: getBool("showRedo"),
    save: getBool("showSave"),
    download: getBool("showDownload"),
    emoji: getBool("showEmoji"),
    eraser: getBool("showEraser"),
    reset: getBool("showReset"),
  };
};

const MainAnnotator = () => {
  const {
    fileUrl,
    studentId,
    fileId,
    instId,
    authToken,
    attachId,
    fileName
  } = getParamsFromQuery();

  const tools = getToolVisibility();

  const isPdf = fileUrl?.toLowerCase().endsWith(".pdf");
return isPdf ? (
    <PdfAnnotator
      key={fileUrl} // 👈 force remount when fileUrl changes
      fileUrl={fileUrl}
      studentId={studentId}
      fileId={fileId}
      instId={instId}
      authToken={authToken}
      attachId={attachId}
      fileName={fileName}
      tools={tools}
    />
  ) : (
    <ImageAnnotator
      key={fileUrl} // 👈 force remount when fileUrl changes
      fileUrl={fileUrl}
      studentId={studentId}
      fileId={fileId}
      instId={instId}
      authToken={authToken}
      attachId={attachId}
      fileName={fileName}
      tools={tools}
    />
  );
  
  
};

export default MainAnnotator;
